document.addEventListener('DOMContentLoaded', function() {
  // Auto-initialize all swipers with data-swiper attribute
  const swipers = document.querySelectorAll('[data-swiper]');
  
  swipers.forEach(function(swiperElement) {
    // Get configuration from data attributes
    const swiperType = swiperElement.dataset.swiper;
    const autoplayValue = swiperElement.dataset.auto;
    const columns = parseInt(swiperElement.dataset.items) || 1;
    const margin = swiperElement.dataset.margin !== undefined ? parseInt(swiperElement.dataset.margin) : 0;
    const loop = swiperElement.dataset.loop === 'true';
    const width = swiperElement.dataset.width || '100%';
    
    // Apply width
    swiperElement.style.width = width;
    if (width !== '100%') {
      swiperElement.style.margin = '0 auto'; // Center the swiper if width is less than 100%
    }
    
    // Base configuration
    const config = {
      slidesPerView: columns,
      spaceBetween: margin,
      loop: loop,
      
      // Autoplay configuration
      autoplay: autoplayValue && autoplayValue !== '' && autoplayValue !== '0' ? {
        delay: parseInt(autoplayValue),
        disableOnInteraction: false
      } : false,
    };
    
    // Slideshow-specific configurations
    if (swiperType === 'slideshow') {
      // Effect configuration
      const transition = swiperElement.dataset.transition;
      if (transition === 'fade') {
        config.effect = 'fade';
        config.fadeEffect = {
          crossFade: true
        };
        
      } else {
        config.effect = 'slide';
      }
      
      // Navigation configuration
      const showNav = swiperElement.dataset.nav === 'true';
      if (showNav) {
        config.navigation = {
          nextEl: swiperElement.querySelector('.swiper-button-next'),
          prevEl: swiperElement.querySelector('.swiper-button-prev'),
        };
      }
      
      // Pagination configuration
      const showPagination = swiperElement.dataset.pagination === 'true';
      if (showPagination) {
        config.pagination = {
          el: swiperElement.querySelector('.swiper-pagination'),
          clickable: true,
        };
      }
      
      // Slideshow doesn't need lazy loading - images load immediately
      config.preloadImages = true;
      config.watchSlidesProgress = true;
      config.speed = 600;
      
    } else {
      // Default carousel configuration with responsive breakpoints
      // Ensure equal heights for carousel items
      config.autoHeight = false;
      
      // Get slidesPerView values for each breakpoint
      const slides320 = parseInt(swiperElement.dataset['320']) || columns;
      const slides480 = parseInt(swiperElement.dataset['480']) || columns;
      const slides640 = parseInt(swiperElement.dataset['640']) || columns;
      const slides768 = parseInt(swiperElement.dataset['768']) || columns;
      const slides992 = parseInt(swiperElement.dataset['992']) || columns;
      const slides1200 = parseInt(swiperElement.dataset['1200']) || columns;
      const slides1600 = parseInt(swiperElement.dataset['1600']) || columns;
      
      // Check if this slider should use group sliding (data-group-slide="true")
      const useGroupSlide = swiperElement.dataset.groupSlide === 'true';
      
      if (useGroupSlide) {
        // Set slidesPerGroup to match slidesPerView for group sliding
        config.slidesPerGroup = columns;
        
        config.breakpoints = {
          320: { 
            slidesPerView: slides320,
            slidesPerGroup: slides320,
            spaceBetween: margin
          },
          480: { 
            slidesPerView: slides480,
            slidesPerGroup: slides480,
            spaceBetween: margin
          },
          640: { 
            slidesPerView: slides640,
            slidesPerGroup: slides640,
            spaceBetween: margin
          },
          768: { 
            slidesPerView: slides768,
            slidesPerGroup: slides768,
            spaceBetween: margin
          },
          992: { 
            slidesPerView: slides992,
            slidesPerGroup: slides992,
            spaceBetween: margin
          },
          1200: { 
            slidesPerView: slides1200,
            slidesPerGroup: slides1200,
            spaceBetween: margin
          },
          1600: { 
            slidesPerView: slides1600,
            slidesPerGroup: slides1600,
            spaceBetween: margin
          }
        };
      } else {
        // Default: slide 1 by 1
        config.slidesPerGroup = 1;
        
        config.breakpoints = {
          320: { 
            slidesPerView: slides320,
            slidesPerGroup: 1,
            spaceBetween: margin
          },
          480: { 
            slidesPerView: slides480,
            slidesPerGroup: 1,
            spaceBetween: margin
          },
          640: { 
            slidesPerView: slides640,
            slidesPerGroup: 1,
            spaceBetween: margin
          },
          768: { 
            slidesPerView: slides768,
            slidesPerGroup: 1,
            spaceBetween: margin
          },
          992: { 
            slidesPerView: slides992,
            slidesPerGroup: 1,
            spaceBetween: margin
          },
          1200: { 
            slidesPerView: slides1200,
            slidesPerGroup: 1,
            spaceBetween: margin
          },
          1600: { 
            slidesPerView: slides1600,
            slidesPerGroup: 1,
            spaceBetween: margin
          }
        };
      }

      // Pagination configuration for carousel
      const paginationEl = swiperElement.querySelector('.swiper-pagination');
      if (paginationEl) {
        config.pagination = {
          el: paginationEl,
          clickable: true,
        };
      }
    }
    
    // Initialize Swiper
    new Swiper(swiperElement, config);
  });


});